"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _stopPropagation = _interopRequireDefault(require("../../utils/stop-propagation"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Dropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown() {
    var _this;

    (0, _classCallCheck2["default"])(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      highlighted: -1
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(value);
      }

      _this.toggleExpansion();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setHighlighted", function (highlighted) {
      _this.setState({
        highlighted: highlighted
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleExpansion", function () {
      var _this$props = _this.props,
          doExpand = _this$props.doExpand,
          doCollapse = _this$props.doCollapse,
          expanded = _this$props.expanded;

      if (expanded) {
        doCollapse();
      } else {
        doExpand();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Dropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      if (this.props.expanded && !props.expanded) {
        this.setState({
          highlighted: -1
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          expanded = _this$props2.expanded,
          children = _this$props2.children,
          className = _this$props2.className,
          optionWrapperClassName = _this$props2.optionWrapperClassName,
          ariaLabel = _this$props2.ariaLabel,
          onExpandEvent = _this$props2.onExpandEvent,
          title = _this$props2.title;
      var highlighted = this.state.highlighted;
      var options = children.slice(1, children.length);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("rdw-dropdown-wrapper", className),
        "aria-expanded": expanded,
        "aria-label": ariaLabel || "rdw-dropdown"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "rdw-dropdown-selectedtext",
        onClick: onExpandEvent,
        title: title
      }, children[0], /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          "rdw-dropdown-carettoclose": expanded,
          "rdw-dropdown-carettoopen": !expanded
        })
      })), expanded ? /*#__PURE__*/_react["default"].createElement("ul", {
        className: (0, _classnames["default"])("rdw-dropdown-optionwrapper", optionWrapperClassName),
        onClick: _stopPropagation["default"]
      }, _react["default"].Children.map(options, function (option, index) {
        var temp = option && /*#__PURE__*/_react["default"].cloneElement(option, {
          onSelect: _this2.onChange,
          highlighted: highlighted === index,
          setHighlighted: _this2.setHighlighted,
          index: index
        });

        return temp;
      })) : undefined);
    }
  }]);
  return Dropdown;
}(_react.Component);

exports["default"] = Dropdown;
(0, _defineProperty2["default"])(Dropdown, "propTypes", {
  children: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  doExpand: _propTypes["default"].func,
  doCollapse: _propTypes["default"].func,
  onExpandEvent: _propTypes["default"].func,
  optionWrapperClassName: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  title: _propTypes["default"].string
});